import { render, staticRenderFns } from "./Placy.vue?vue&type=template&id=4f466152&scoped=true&"
import script from "./Placy.vue?vue&type=script&lang=js&"
export * from "./Placy.vue?vue&type=script&lang=js&"
import style0 from "./Placy.vue?vue&type=style&index=0&id=4f466152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f466152",
  null
  
)

export default component.exports